<template>
  <v-text-field
    v-model="keyword"
    append-icon="search"
    v-on:blur="handleBlur"
    placeholder="ID/タイトル/メモを検索"
    @keyup="checkTextLimit($event,'keyword',100)"
    @keydown="checkTextLimit($event,'keyword',100)"
    @keypress.enter="search()"
    class="UXinput UXicon-search"
    style="max-width: 500px;"
    hide-details
    outline
    solo
  ></v-text-field>
</template>

<script>
import TicketListUtil from '../../../util/ticket_list_util'
import OptionType from '../../../enums/ticketListOptionType'

export default {
  name: 'search_ticket_keyword',
  props: {
    updateOption: Function,
    pageType: String,
    isLoading: Boolean
  },
  data () {
    return {
      keyword: '',
      isClick: false
    }
  },
  watch: {
    isLoading (val) {
      if (val === false) this.isClick = false
    }
  },
  methods: {
    search () {
      if (!this.isLoading && !this.isClick) {
        this.isClick = true
        this.updateOption('ticketSearch', this.keyword)
      } else if (!this.isLoading) {
        this.isClick = false
      }
    },
    handleBlur () {
      this.search()
    },
    resetAll () {
      this.keyword = null
    },
    checkTextLimit (event, key, limitCnt) {
      // 방향키 37~40 , backspace 8, delete key 46
      const isAllowKeyCodes = [8, 37, 38, 39, 40, 46]
      // 복사,붙혀넣기,전체선택
      const copyPaste = ((event.ctrlKey || event.metaKey) && (event.keyCode === 67 || event.keyCode === 86 || event.keyCode === 65))
      const allowed = isAllowKeyCodes.includes(event.keyCode) || copyPaste
      if (!allowed) {
        if (this[key] && this[key].length > limitCnt) {
          event.preventDefault()
          this.$toasted.clear()
          this.$toasted.error('検索キーワードの最大入力文字数(100字)を超えました。')
        }
        if (this[key] && this[key].length > limitCnt) {
          this[key] = this[key].substr(0, limitCnt)
        }
      }
    }
  },
  mounted () {
    this.keyword = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.TICKET_SEARCH, localStorage.getItem('TICKET_LIST_OPTION'))
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/input/search_ticket_keyword.vue